import { Color, DropdownMenuTriggerTheme } from '../../enums';

export const getIconMenuColor: (isActive: boolean, theme: DropdownMenuTriggerTheme) => Color = (
  isActive: boolean, theme: DropdownMenuTriggerTheme
): Color => {
  switch (theme) {
    case DropdownMenuTriggerTheme.Black:
      return isActive ? Color.Error500 : Color.Black;
    case DropdownMenuTriggerTheme.White:
      return isActive ? Color.Gray300 : Color.White;
    default:
      return Color.Black;
  }
};
